function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M54.0002 66.999C83.8237 66.999 108 61.7496 108 55.2742C108 48.7987 83.8237 43.5493 54.0002 43.5493C24.1767 43.5493 0 48.7987 0 55.2742C0 61.7496 24.1767 66.999 54.0002 66.999Z",
  fill: "#35383D"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M74.8437 4.32512L74.8881 4.39622L74.9439 4.45891L91.8128 23.4404V37.5371H16.1875V23.442L33.0565 4.45717L33.112 4.39472L33.1563 4.32393C33.8539 3.21063 34.7726 2.6875 35.5945 2.6875H72.4058C73.2275 2.6875 74.146 3.21041 74.8437 4.32512Z",
  fill: "#6E7176",
  stroke: "#46494E",
  strokeWidth: 2
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M70.2221 28.3718C70.2221 25.6834 71.8995 23.4641 73.9802 23.4624H92.8128V53.8415C92.8128 57.3975 90.5853 60.3119 87.8346 60.3119H20.1656C17.415 60.3119 15.1875 57.3958 15.1875 53.8415V23.4624H34.0201C36.1008 23.4624 37.7781 25.6784 37.7781 28.3667V28.4036C37.7781 31.0919 39.4741 33.2627 41.5531 33.2627H66.4472C68.5262 33.2627 70.2221 31.0718 70.2221 28.3835V28.3718Z",
  fill: "#46494E"
});

var SvgEmptyIcon = function SvgEmptyIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 108,
    height: 68,
    viewBox: "0 0 108 68",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEmptyIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/EmptyIcon.e2fa7060.svg";
export { ForwardRef as ReactComponent };